export const HEADER_NAV_LOCATION_ID = 'header_nav'
export const MOBILE_DRAWER_NAV_LOCATION_ID = 'mobile_drawer_nav'

export const HEADER_CHECK_AVAILABILITY_BUTTON_ID = 'header_check_availability_button'
export const HEADER_SIGN_IN_BUTTON_ID = 'header_sign_in_button'
export const HEADER_YOUR_ACCOUNT_BUTTON_ID = 'header_your_account_button'

export const DRAWER_CHECK_AVAILABILITY_BUTTON_ID = 'drawer_check_availability_button'
export const DRAWER_SIGN_IN_BUTTON_ID = 'drawer_sign_in_button'
export const DRAWER_YOUR_ACCOUNT_BUTTON_ID = 'drawer_your_account_button'

export const MOBILE_DRAWER_NAV_TOGGLE_BUTTON_ID = 'mobile_drawer_nav_toggle_button'
